import { FolderQuestionIcon } from './FolderQuestionIcon';

/**
 * author: Michael Irigoyen
 * id 772568CD-A665-4EBA-ACEA-6D6D5D23CDFB
 * name folder-question
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-question.svg
 * tags
 * - Files / Folders 
 */
export const FolderHelpIcon = FolderQuestionIcon;
export default FolderHelpIcon